<template>
	<div class="info row">
		<div class="user-container">
			<div class="user-container__name">{{ userInfo.firstName }} {{ userInfo.lastName }}</div>
			<div class="user-container__status enable">{{ userInfo.userRoles.roleName }}</div>
		</div>
		<div class="actions" @click="logout" v-if="!isMobile">
			<div class="actions__btn">
				<ExitIcon class="actions__btn-icon" />
				<p class="actions__btn-text">Sair</p>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import clearApp from '@/utils/clearApp';
import LockIcon from '@/components/shared/Icons/LockIcon.vue';
import ExitIcon from '@/components/shared/Icons/ExitIcon.vue';

export default {
	name: 'UserInfo',
	components: { LockIcon, ExitIcon },
	props: {
		isMobile: {
			default: false,
		},
	},
	data: () => ({
		title: '',
		isOpen: false,
	}),
	mounted() {},
	methods: {
		openProfileMenu() {
			this.isOpen = !this.isOpen;
		},
		closeDropdown() {
			this.isOpen = false;
		},
		logout() {
			clearApp();
			this.$router.push('/login');
		},
	},
	computed: {
		...mapGetters('login', ['userInfo']),
	},
};
</script>

<style lang="scss" scoped>
@import 'UserInfo.scss';
</style>
